import { render } from "./VisualizarProfissional.vue?vue&type=template&id=206fc7fa&scoped=true"
import script from "./VisualizarProfissional.vue?vue&type=script&lang=js"
export * from "./VisualizarProfissional.vue?vue&type=script&lang=js"

import "./VisualizarProfissional.vue?vue&type=style&index=0&id=206fc7fa&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206fc7fa"]])

export default __exports__